/** @jsx jsx */

import { jsx } from '@emotion/core';
import { Grid, Icon, Text } from '@zapier/design-system';

import { ValidationCheckType } from 'app/developer-v3/types';

import { checkMap, iconsMap } from '../constants';

type Props = {
  icon: 'errors' | 'warnings';
  check: ValidationCheckType;
  violationType: string;
};

/**
 * Renders the title section with
 * [icon] [check type name] [violation type]
 */
const Title = ({ icon, violationType, check }: Props) => (
  <Grid alignItems="center" columns="repeat(2, auto) 1fr" gap={5}>
    <Icon size={20} {...iconsMap[icon]} />
    <Text fontWeight={600}>{checkMap[check]}</Text>{' '}
    <Text>({violationType})</Text>
  </Grid>
);

export default Title;
